<template>
  <div>
    <wc-section-title title='Project Routing' fullWidth class='ml-2'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'project-routing-module-base',
  computed: {
    menu () {
      return [
        {
          title: 'Schedule Dashboard',
          icon: this.$store.state.icons.modules.schedule.icon,
          route: { name: 'ScheduleDashboard' }
        },
        {
          title: 'Irrigation Routing',
          icon: this.irrigationDiv.icon,
          route: { name: 'DivisionRoutingPage', params: { id: this.irrigationDiv.id } }
        },
        {
          title: 'Lawn Routing',
          icon: this.lawnDiv.icon,
          route: { name: 'DivisionRoutingPage', params: { id: this.lawnDiv.id } }
        },
        {
          title: 'Snow Routing',
          icon: this.snowDiv.icon,
          route: { name: 'DivisionRoutingPage', params: { id: this.snowDiv.id } }
        }
      ]
    },
    irrigationDiv () {
      return _.find(this.$store.state.misc.divisions, d => d.division === 'Irrigation')
    },
    lawnDiv () {
      return _.find(this.$store.state.misc.divisions, d => d.division === 'Lawn')
    },
    snowDiv () {
      return _.find(this.$store.state.misc.divisions, d => d.division === 'Snow')
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Project Routing')
    this.$store.dispatch('loadMainMenu', this.menu)
  } 
}
</script>